/*
 * @Author: 方宾菲
 * @Date: 2025-02-12 14:38:18
 * @LastEditors: 方宾菲
 * @LastEditTime: 2025-02-12 14:38:30
 * @Description: 
 * @FilePath: \ys.gnss\src\assets\icons\svg\index.js
 */
import Vue from 'vue'
import SvgIcon from '@/components/xtgl/sgjdpz/components/formSet/svg-icon'// svg组件

// 全局注册svg组件
Vue.component('SvgIcon', SvgIcon)

// ./表示svg图标所在的文件夹icons,然后匹配icons文件夹下的的svg图标文件,如果你想把svg放在icons下的svg目录中,这里的./就得改为./svg
const svgRequire = require.context('./', false, /\.svg$/)
// 完成本地svg图标的导入
svgRequire.keys().forEach(svgIcon => svgRequire(svgIcon))